// extracted by mini-css-extract-plugin
module.exports = {"container":"LetterSpacingInput_container__1yzbv","input":"LetterSpacingInput_input__3g6oY"};